import config from 'app/config'
import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer'


export const surveysSettingsKey = 'surveys' as const

export type SurveysSettings = {
  rows: number
}

export const surveysDefaultSettings: SurveysSettings = {
  rows: config.perPageItems,
}

export default makeSettingsReducer(surveysSettingsKey, surveysDefaultSettings)
